import api from './axios'

const nameConnectionPrimary = 'primary'

export class ServiceWhatsaApp {
  static async findall () {
    const response = await api.get('/crm')

    return response.data
  }

  static async update (id, body) {
    const response = await api.put('/crm/' + id, body)

    return response.data
  }

  static async getQrCodePrimary (nameConnection) {
    const responseConnect = await api.post('/integration-whatsapp/connect', {
      nameConnection: nameConnection || nameConnectionPrimary
    })

    if (responseConnect.status !== 200) {
      throw new Error('Estamos com problemas na integração com o WhatsApp')
    }

    const responseQrCode = await api.get('/integration-whatsapp/qrcode?nameConnection=' + nameConnection || nameConnectionPrimary)

    if (responseQrCode.status !== 200) {
      throw new Error('Estamos com problemas na integração com o WhatsApp')
    }


    return responseQrCode.data
  }

  static async healthCheck (nameConnection) {
    const response = await api.get('/integration-whatsapp/health?nameConnection=' + nameConnection || nameConnectionPrimary)

    if (response.status !== 200) {
      throw new Error('Estamos com problemas na integração com o WhatsApp')
    }

    return response.data
  }

  static async me (nameConnection) {
    const response = await api.get('/integration-whatsapp/me?nameConnection=' + nameConnection || nameConnectionPrimary)

    if (response.status !== 200) {
      throw new Error('Estamos com problemas na integração com o WhatsApp')
    }

    return response.data
  }

  static async disconnect (nameConnection) {
    const response = await api.get('/integration-whatsapp/disconnect?nameConnection=' + nameConnection || nameConnectionPrimary)

    if (response.status !== 200) {
      return false
    }

    return true
  }
}